import * as Specular$dInternal$dIncremental$dOptional from "../Specular.Internal.Incremental.Optional/index.js";
import {_foreachUntil} from "./foreign.js";
const foreachUntil = (array, fn) => _foreachUntil(Specular$dInternal$dIncremental$dOptional.none, array, fn);
export {foreachUntil};
export * from "./foreign.js";
